import React, {Component} from "react";
import {observer, inject} from 'mobx-react';
import {withRouter} from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from '../components/PageWrapper';
import ResourceItem from '../components/ResourceItem';

const resourceUrl = '/api/v1/resourses';
const TOPICS_REQUEST = '/api/v1/tutorials/';

@withRouter
@inject('resourcesStore')
@inject('examPrepHeaderStore')
@inject('topicsStore')
@inject('alertStore')
@observer
class Resources extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationModalOpen: false,
      topic: null,
    };
  }

  extractContent = description => {
    const span = document.createElement('span');
    span.innerHTML = description;
    return span.textContent || span.innerText;
  }

  componentWillMount() {
    const {topicsStore, match, examPrepHeaderStore: {setTopic}} = this.props;
    const id = match.params.id;//location.pathname.replace('/topic/', '');

    if(id) {
      new HttpClient().get(`${TOPICS_REQUEST}${id}`).then(data => {
        const topic = data.body.data.tutorial;
        const spd_quizzes = topic.spd_quizzes;
        let sortedQuizz = spd_quizzes.length > 0 ? _.sortBy(spd_quizzes, 'id') : EMPTY_CPD_QUIZES;
        sortedQuizz = topic.reimbursement_type === 'regular' ? sortedQuizz : sortedQuizz.map(quiz => {
          const quizOptions = quiz.options ? quiz.options : [];
          const options = quizOptions.map(option => JSON.parse((option || '').replaceAll('=>', ':')));

          return {
            ...quiz,
            options,
          };
        });

        const topicWithVideo = {
          ...topic,
          tutorial_videos_attributes: topic.videos,
          podcasts_attributes: topic.podcasts,
        }
        const withDescription = !!this.extractContent(topic.description);
        const topicWithSortedQuizz = {
          ...topicWithVideo,
          withDescription,
          spd_quizzes: sortedQuizz,
        };
        topicsStore.setTopic(topicWithSortedQuizz);

        if (topic.tutorial_type !== 'regular') {
          setTopic(topic);
        }
      }).catch( (e) => {
        console.log(e)
        if(e.status === 403) {
          this.props.history.push('/settings/payments');
        }
      });
    }
  }

  componentDidMount() {
    const {resourcesStore, location} = this.props;

    new HttpClient().get(`${resourceUrl}${location.search}`).then(response => {
      resourcesStore.setResources(response.body.data.resourse);
    });
  }

  onResourceEdit = resource => {
    this.props.history.push(`/resources/${resource.id}/edit`);
  };

  openDeleteConfirmModal = resource => {
    const {resourcesStore} = this.props;

    resourcesStore.setResource(resource);
    this.setState({ confirmationModalOpen: true });
  }

  closeDeleteConfirmModal = () => {
    const {resourcesStore} = this.props;
    resourcesStore.initNewResource();

    this.setState({ confirmationModalOpen: false });
  }

  deleteResource = () => {
    const { resource } = this.props.resourcesStore;
    new HttpClient().delete(`${resourceUrl}/${resource.id}`).then((res) => {
      if(res.status === 200) {
        this.closeDeleteConfirmModal();
        this.props.resourcesStore.deleteResource(resource.id);
        this.props.alertStore.success('You successfully deleted Practice Case');
      }
    }).catch((e) => {
      this.closeDeleteConfirmModal();
      this.props.alertStore.success('Something went wrong');
    });
  }

  getTitle = (type) => {
    switch (type) {
      case 'cct':
        return 'Practice Cases';
      case 'ckt':
        return 'Revision Summaries';
      default:
        return '';
    }
  };

  render()  {
    const {confirmationModalOpen} = this.state;
    const {resourcesStore, location} = this.props;
    const {resources} = resourcesStore;
    const customContentStyle = {
      height: '100%',
      maxHeight: 'none'
    };
    const type = location.search.replace('?resourse_type=', '');
    const title = this.getTitle(type);

    return (
      <PageWrapper>
        <Dialog
          title='Are you sure you want to delete this Resource?'
          modal={true}
          open={confirmationModalOpen}
          customContentStyle={customContentStyle}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={true}>
          <div className="button-set">
            <button className="btn gray small transparanted cancel-btn" type="reset"
              onClick={this.closeDeleteConfirmModal}>No
              </button>
            <button className="btn gray small transparanted apply-btn" type="submit"
              onClick={this.deleteResource}>Yes
              </button>
          </div>
        </Dialog>
        <div className="resources-container">
          <h2>{title}</h2>
          <div className="resources-list">
            {resources.map(resource => (
              <ResourceItem
                key={resource.id}
                resource={resource}
                openDeleteModal={this.openDeleteConfirmModal}
              />
            ))}
          </div>
        </div>
      </PageWrapper>
    );
  }
};

export default Resources;



// WEBPACK FOOTER //
// ./src/modules/resources/containers/Resources.js